/* eslint-disable @typescript-eslint/no-var-requires */
import React, { FunctionComponent, MutableRefObject, useRef } from 'react';

import './animation020.less';
import { Timeline } from 'antd';

interface IAnimation020Item {
  icon: string;
  color: string;
  time: string;
  title: string;
  list: [];
}

interface IAnimation020Props {
  items: IAnimation020Item[];
  onCompleted: () => void;
}

const Animation020: FunctionComponent<IAnimation020Props> = ({
  items,
  onCompleted,
}) => {
  const crrRef = useRef() as MutableRefObject<HTMLDivElement>;
  const getImg = (img: string) =>
    require(`../../../../../assets/${img}`).default;

  return (
    <div className="animation020-content">
      <div ref={crrRef} className="animation020 component">
        {items.map((itm: IAnimation020Item, idx: number) => (
          <div
            key={idx}
            className={`animation020-item animation020-item-${idx}`}
            style={{
              width: `${(1 / items.length) * 100}%`,
            }}
          >
            <>
              <div className="animation020-head">
                <div
                  className="animation020-time"
                  dangerouslySetInnerHTML={{ __html: itm.time }}
                />
                <div
                  className="animation020-title"
                  dangerouslySetInnerHTML={{ __html: itm.title }}
                />
              </div>
              <div className="animation020-line"></div>
              <div className="animation020-list">
                <Timeline>
                  <Timeline.Item
                    color={itm.color}
                    key={0}
                    className={`animation020-text animation020-text-0`}
                    dot={
                      <div
                        style={{
                          padding: '0',
                          height: '60px',
                          width: '60px',
                          backgroundColor: itm.color,
                          border: `2px solid ${itm.color}`,
                          borderRadius: '60px',
                          backgroundImage: `url(${getImg(itm.icon)})`,
                          backgroundRepeat: 'no-repeat',
                          backgroundPosition: 'center',
                        }}
                      />
                    }
                  />
                  {itm.list.map((element, index) => {
                    return (
                      <Timeline.Item
                        color={itm.color}
                        key={`item-${idx}-${index + 1}`}
                        className={`animation020-text animation020-text-
                        ${index + 1}`}
                        dot={
                          <div
                            style={{
                              padding: '0',
                              height: '18px',
                              width: '18px',
                              backgroundColor: itm.color,
                              border: `2px solid ${itm.color}`,
                              borderRadius: '18px',
                            }}
                          />
                        }
                      >
                        <div
                          className="animation020-detail-text"
                          dangerouslySetInnerHTML={{ __html: element }}
                        />
                      </Timeline.Item>
                    );
                  })}
                </Timeline>
              </div>
            </>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Animation020;
